<div class="admin-shell">
    <header class="admin-shell__header">
        <div class="admin-shell__brand">
            <img
                class="admin-shell__logo"
                [src]="
                    themeService.isDark()
                        ? 'assets/img/v2/logo-sem-fundo-dark.png'
                        : 'assets/img/v2/logo-sem-fundo-ligth.png'
                "
                alt="RAADS"
            />
            <span class="admin-shell__title">{{ 'admin.shell.title' | transloco }}</span>
        </div>
        <div class="admin-shell__actions">
            <app-theme-switcher buttonClass="theme-toggle-btn"></app-theme-switcher>
            <button type="button" class="admin-shell__back" (click)="goBackToApp()">
                <mat-icon>chevron_left</mat-icon>
                {{ 'admin.shell.back' | transloco }}
            </button>
        </div>
    </header>

    <div class="admin-shell__body">
        <app-admin-side-nav></app-admin-side-nav>

        <main class="admin-shell__content v2-active">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
